import { lazy } from 'react';

// Tras un deploy, los chunks con hash antiguo dejan de existir. Una pestaña abierta
// desde antes del deploy fallaría al navegar lazy (p. ej. logout → LoginPage) con
// "Failed to fetch dynamically imported module". Recargamos la página una sola vez:
// el navegador relee index.html y obtiene los hashes nuevos. El flag en sessionStorage
// evita un bucle de reload si el fallo no se debe a un chunk obsoleto.
const CHUNK_RELOAD_KEY = 'klonup:chunk-reload';

export function lazyWithReload<T extends { default: React.ComponentType<unknown> }>(
  factory: () => Promise<T>,
) {
  return lazy(async () => {
    try {
      const module = await factory();
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      return module;
    } catch (error) {
      // No es E93: el mensaje nunca se muestra al usuario, solo decide si recargar
      // la página tras un chunk obsoleto.
      // eslint-disable-next-line no-restricted-syntax -- ver comentario anterior
      const message = error instanceof Error ? error.message : String(error);
      const isStaleChunk = /dynamically imported module|Failed to fetch|Importing a module script failed/i.test(message);
      const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';

      if (isStaleChunk && !alreadyReloaded) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
        window.location.reload();
        // La página se está recargando: devolvemos una promesa que nunca resuelve
        // para que Suspense mantenga el fallback hasta el reload.
        return new Promise<T>(() => {});
      }
      throw error;
    }
  });
}
